import { Spinner, Table } from "react-bootstrap";
import { axiosGetWithHeader,axiosPostWithHeader,ShowAlertError2 } from "../../Common/axios";
import { useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export function OptionsRecentlyViewed()  {
  const [spinner, setSpinner] = useState('Loading - Recent Options');
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  const [errorAlert, setErrorAlert] = useState(null);
  const [optionSearch, setOptionSearch] = useState([]);
  const [message, setMessage] = useState(["You have not done any options recently."]);
  const optionSearchReference = useRef();

  useMemo(() => {
    axiosGetWithHeader("/options/recent",
      (response)=>{
        setUserData(response.data);
        setSpinner(null);
      },
      (error)=>{
        setUserData(null);
        setSpinner(null);
        console.log(error);
        setErrorAlert(error.message);
      }
    );
  }, []);

  function handleClick(runningId){
    setTimeout(() => {
      navigate('/optionstheory.html', { state:{runningId:runningId}, replace: true });
      navigate(0);
    }, 100);
  }

  var callCommand=(event)=>{
    var keyValue = event.target.value;
    setOptionSearch(keyValue);
  }

  var onOptionSearch=()=> {
    if(optionSearch===null||optionSearch===undefined||optionSearch.length===0) {
      setMessage("Please enter Name to search");
      optionSearchReference.current.focus();
      return;
    }
    if(optionSearch.length<3) {
      setMessage("Please enter few more characters to search");
      optionSearchReference.current.focus();
      return;
    }
    const data = {
      keyword : optionSearch,
    }

    axiosPostWithHeader("/options/search",data,
      (response)=>{
        setUserData(response.data);
        setSpinner(null);
        if(response.data===null || response.data===undefined || response.data.length===0) {
          setMessage("No Options found for the name "+optionSearch);
        }
      },
      (error)=>{
        setUserData(null);
        setSpinner(null);
        setMessage("Error occurred while searching");
        console.log(error);
        setErrorAlert(error.message);
      }
    );
  }

  return (
    <>
    {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
    <div class="m-2 p-0 row align-items-top content ">
      <div class="m-0 p-0 col-sm-12 col-md-12 text-center">
        <Table responsive border-none hover size="sm" className="caption-top m-0 p-0 ">
          <caption className="text-center">
            <h5>Options Theory</h5>
          </caption>
        </Table>

        <div class="row m-0 p-0 w-100 border rounded">
          <div class="col m-0 p-3 justify-content-center">

          <div class="input-group ">
            <input type="input" ref={optionSearchReference} class="form-control" id="optionSearch" placeholder="Search by Name" title="Type few characters of Name" name="optionSearch" 
              value={optionSearch} onChange={callCommand}/>
            <span class="input-group-text" >
              <button class="navbar-brand m-0 p-0 btn btn-white border-0" onClick={onOptionSearch}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
              </svg>
              </button>
            </span>
            <span class="input-group-text" >
              <Link to="/optionstheory.html">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
              </svg>
              </Link>
            </span>
          </div>
          <Table responsive border-none hover size="sm" className="caption-top m-0 p-0 ">
            <thead>
              <tr class=" m-2 p-2">
                <th class="bg-transparent">#</th>
                <th class="bg-transparent">Name</th>
                <th class="bg-transparent">Date</th>
              </tr>
            </thead>
            <tbody>
            { userData===null || userData===undefined || userData.length===0?
            <>
              <tr>
                  <td colSpan={3} class="bg-transparent">{message}</td>
              </tr>
            </>
            :
            <>
              {userData.map((user, rowindex) => (
                <tr onClick={e=>handleClick(user.runningId)}>
                  <td class="bg-transparent">{user.runningId}</td>
                  <td class="bg-transparent text-start">{user.firstName} {user.lastName}</td>
                  <td class="bg-transparent">{user.date}</td>
                </tr>
              ))}
            </> 
            }
            </tbody>
          </Table>
          </div>
        </div>
      </div>
    </div>
    <ShowAlertError2 errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
    </>
  );
}
  